import { render, staticRenderFns } from "./NewsSubscriptionForm.vue?vue&type=template&id=4be21a54&lang=pug&"
import script from "./NewsSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./NewsSubscriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports